import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AllErrorsComponent, NotFoundPageComponent } from './error-handlers';
import { AuthGuardService } from './shared/web-guards';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./features/index').then((m) => m.AuthModule)
  },
  {
    path: 'user',
    loadChildren: () =>
      import('./shared/shared-api').then((m) => m.SidebarModule),
    canActivate: [AuthGuardService],
  },
  {
    path: 'not-found',
    component: NotFoundPageComponent
  },
  {
    path: 'error/:code',
    component: AllErrorsComponent
  },
  {
    path: '**',
    redirectTo: 'not-found',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
